export default __webpack_public_path__ + "static/media/1x2-gaming.13936b0a.png";